// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"e381f80e","396":"e381f80e","932":"2a7fd61e"}[chunkId] + ".chunk.css";
};